import { render, staticRenderFns } from "./CaseCover.vue?vue&type=template&id=04fd9dea"
import script from "./CaseCover.vue?vue&type=script&lang=js"
export * from "./CaseCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports